import { useAppSelector } from "@evr/hooks/reduxHooks";
import { selectScheduledJourneysQuery } from "@evr/store/slices/scheduled-journeys";

import { useScheduledJourneysQuery } from "..";

export const useGetScheduledJourneysQuery = () => {
  const queryParams = useAppSelector(selectScheduledJourneysQuery);
  return useScheduledJourneysQuery(queryParams);
};
